import { Route, Switch } from 'react-router-dom';
import BranchesLogScreen from './screens/BranchesLogScreen/BranchesLogScreen';
import { Table } from 'src/view/components/Table/Table';
import { SCREENS } from 'src/constants/screens';

const BranchLogScreen = () => {
  return (
    <Table>
      <Switch>
        {/* Branches Log */}
        <Route path={[SCREENS.BRANCHES_LOG(), SCREENS.BRANCH_LOG(':id')]} component={BranchesLogScreen} />
      </Switch>
    </Table>
  );
};

export default BranchLogScreen;
